import { createContext } from 'react';
import type { LatLngBoundsLiteral } from 'leaflet';

type Context = {
  fitMap: (soft?: boolean, target?: LatLngBoundsLiteral, force?: boolean) => void;
  toggleMarkerClusters: () => void;
  toggleFullScreen: () => void;
  toggleFullScreenDashboard: () => void;
};

const Context = createContext<Context>({
  fitMap: () => {},
  toggleMarkerClusters: () => {},
  toggleFullScreen: () => {},
  toggleFullScreenDashboard: () => {},
});

export default Context;
